import { createContext, useContext, useState, useEffect } from 'react';
import api from './apiCore';
import { resetChatSocket } from './chatSocket';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      api.setTokens(accessToken, localStorage.getItem('refreshToken'));
      loadUser();
    } else {
      setLoading(false);
    }
  }, []);

  const loadUser = async () => {
    try {
      const profile = await api.getProfile();
      setUser(profile);
    } catch (error) {
      console.error('Failed to load user:', error);
      api.logout();
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password, captchaToken) => {
    try {
      resetChatSocket();
      await api.login(username, password, captchaToken);
      await loadUser();
      return true;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  };

  const register = async (username, password, captchaToken) => {
    try {
      await api.register(username, password, captchaToken);
      return true;
    } catch (error) {
      console.error('Registration failed:', error);
      throw error;
    }
  };

  const logout = async () => {
    resetChatSocket();
    await api.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, loadUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

